import axios from "axios";
import authHeader from '../../../authheader'

const VFAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/FirmVfApplication";

const getContactInformation = (applicationId) => {
    return axios.get(`${VFAPPLICATIONURL}/contactinformation`, { headers: authHeader(), params: { applicationId } });
}
//const postContactInformation = (applicationId, certDisplayName) => {
//    return axios.post(`${VFAPPLICATIONURL}/contactinformation`, null, { headers: authHeader(), params: { applicationId, certDisplayName } });
//}
export default {
    getContactInformation,
    //postContactInformation
}